/**
 * Maps URL path segments to their corresponding browser tab titles.
 * Entries are evaluated in order — more-specific paths must come before
 * their prefixes (e.g. '/manage-access/add-access' before '/manage-access').
 */
export const ROUTE_TITLE_MAP: ReadonlyArray<{ segment: string; title: string }> = [
  { segment: '/my-teams',               title: 'UBT – My Teams' },
  { segment: '/add-profile',            title: 'UBT – Add Profile' },
  { segment: '/edit-ubt',               title: 'UBT – Edit UBT' },
  { segment: '/select-ubt',             title: 'UBT – Select UBT' },
  { segment: '/manage-access/add-access', title: 'UBT – Add Access' },
  { segment: '/manage-access',          title: 'UBT – Manage Access' },
  { segment: '/projects',               title: 'UBT – Projects' },
  { segment: '/history',                title: 'UBT – History' },
  { segment: '/contact-us',             title: 'UBT – Contact Us' },
  { segment: '/members',                title: 'UBT – Members' },
  { segment: '/search-teams',           title: 'UBT – Search Projects' },
  { segment: '/path-to-performance',    title: 'UBT – Path to Performance' },
  { segment: '/teams-reporting',        title: 'UBT – Teams Reporting' },
  { segment: '/team-documents',         title: 'UBT – Team Documents' },
  { segment: '/home',                   title: 'UBT – Home' },
  { segment: '/login',                  title: 'UBT – Login' },
] as const;

/** Fallback title used when no route segment matches. */
export const DEFAULT_DOCUMENT_TITLE = 'UBT Tracker Admin';
